<template>
  <div :class="['model', type,`${type}${config.uiExt.uiExtTemplate}`, theme]"
    v-if="data.length != 0"
    :style="model"
  >
    <div class="modelTitle" :style="{ backgroundColor: bColor, color: textColor }">
      {{ title }}
    </div>
    <div class="modelBg">
      <div class="list">
        <div class="item" v-for="(item, index) in data" :key="index" @click="$emit('handleCoupon', item)">
          <div class="itemMain" v-if="item.styleType == 1 && item.winType == 4">
            <div :class="['itemInfo', type,`${type}${config.uiExt.uiExtTemplate}`]">
              <div :class="['typeName', type,`${type}${config.uiExt.uiExtTemplate}`]">{{ item.type == 4 ? "折扣" : "立减" }}</div>
              <div class="couponTitle">{{ item.name }}</div>
              <div :class="['couponInfo', type,`${type}${config.uiExt.uiExtTemplate}`]">{{ item.info }}</div>
            </div>
            <div :class="['itemIntro', type,`${type}${config.uiExt.uiExtTemplate}`]">
              <div class="itemIntroBox">
                <div :class="['reduce', type,`${type}${config.uiExt.uiExtTemplate}`]" v-if="item.type == 4">
                  <span> {{ item.discount }}</span> 折
                </div>
                <div :class="['reduce', type,`${type}${config.uiExt.uiExtTemplate}`]" v-if="item.type == 5">
                  <span> {{ item.reduce }}</span
                  >元
                </div>
                <div :class="['receive', type,`${type}${config.uiExt.uiExtTemplate}`]">立即领取</div>
              </div>
            </div>
          </div>

          <div class="itemMain" v-if="item.styleType == 1 && item.winType == 5">
            <div :class="['itemInfo', type,`${type}${config.uiExt.uiExtTemplate}`]">
              <div class="couponTitle">{{ item.name }}</div>
              <div :class="['couponInfo', type,`${type}${config.uiExt.uiExtTemplate}`]" v-html="item.text"></div>
            </div>
            <div :class="['itemIntro', type,`${type}${config.uiExt.uiExtTemplate}`]">
              <div class="itemIntroBox">
                <div :class="['reduce', type,`${type}${config.uiExt.uiExtTemplate}`]">
                  ￥<span>{{ item.amount / 100 }}</span>
                </div>
                <div :class="['receive', type,`${type}${config.uiExt.uiExtTemplate}`]">一键锁定</div>
              </div>
            </div>
          </div>
          <!-- <div class="itemMain" v-if="item.styleType == 2"  :style="{ backgroundImage: ` url(${item.img})` }"> -->
          <!-- <div class="itemMain" v-if="item.styleType == 2"  > -->
            <img v-if="item.styleType == 2"  :src="item.img"/>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "./../utils/common";
export default {
  props: ["data", "bColor", "title", "textColor", "type", "theme"],
  data() {
    return {
      config:this.$configInfo
    };
  },
  watch: {
    data: {
      handler(val) {
        val.map((item) => {
          item.text = (item.info||'').replace(/\n/g, "<br/>");
        });
      },
      deep: true,
    },
  },
  computed: {
    model() {
      if (this.type == "lightup") {
        return { backgroundColor: `${util.rgbToRgba(this.bColor, 0.3)}` };
      }
      if (this.theme == "theme2") {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.5) ,
        };
      }
      return {borderColor: this.bColor,};
    },
  },
  created() {},
  methods: {
    rgba(color, alp) {
      return util.rgbToRgba(color, alp);
    },
  },
};
</script>
<style lang="scss" scoped>
img{
  width: 100%;
}
div{
  box-sizing: border-box;
}
.model {
  width: 351px;
  margin: 56px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  padding: 10px;
  box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
  background:  rgba(255, 255, 255, 0.1);

  &.lucky,&.assistance,&.haggle{
    border: 5px solid;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0;
    background:transparent;
    .modelTitle {
      margin-top: -20px;
      border-radius: 6px;
      display: inline-block;
      font-size: 20px;
      font-weight: bold;
      box-shadow: none;
    }
  }
  &.lightup{
    border: 1px solid rgba(255, 255, 255, 0.1);
    .modelTitle {
      font-size: 20px;
      font-weight: bold;
    }
  }
  &.purchase{
    .modelTitle {
      // font-size: 20px;
    }
  }
  &.cultivate {
    background: rgba(255, 255, 255, 0.9);
    border: 5px solid #58A72A;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    padding: 0;
    .modelTitle {
      margin-top: -20px;
      border-radius: 6px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    }
    .modelBg {
      .list {
        .list {
            margin: 20px 20px 30px;
            .item {
              margin-bottom: 20px;
            }
          }
      }
    }
  }
  &.theme2 {
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background:  rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }
  .modelTitle {
    position: absolute;
    margin-top:-10px;
    color: white;
    padding: 0 16px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    display: inline-block;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 12px 12px;
  }

  .modelBg {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      margin: 60px 15px 25px;

      .item {
        margin-bottom: 14px;

        .itemMain {
          // width: 311px;
          min-height: 100px;
          // background-image: url('https://assets.rurushishi.com/activies/activityCenter/assistanceHelp/coupon.png');
          background-position: top center;
          background-repeat: no-repeat;
          background-size: 100% auto;
          display: flex;
            

          .itemInfo {
            border-radius: 8px;
            width: 270px;
            padding: 29px 70px 29px 20px;
            box-sizing: border-box;
            height: 100%;
            min-height: 100px;
            display: flex;
            flex-direction: column;
            &.lucky{
              background: linear-gradient(180deg, #F89147 4.69%, #F0672E 44.27%, #E84424 83.33%);
              box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2), inset 0px -1px 0px rgba(166, 43, 17, 0.5), inset 0px 1px 0px rgba(255, 195, 158, 0.5);
            }
            &.coupon {
              background: linear-gradient(180deg, #F28353 0%, #E14076 75.52%);
              box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2), inset 0px -1px 0px rgba(166, 43, 17, 0.5), inset 0px 1px 0px rgba(255, 195, 158, 0.5);
            }
            &.purchase{
              background: linear-gradient(180deg, #F28353 0%, #E14076 75.52%);
              box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2), inset 0px -1px 0px rgba(166, 43, 17, 0.5), inset 0px 1px 0px rgba(255, 195, 158, 0.5);
              &0 {
                background: linear-gradient(180deg, #F28353 0%, #E14076 75.52%);
                box-shadow: 0px 0px 8px rgba(142, 48, 27, 0.2), inset 0px -1px 0px rgba(166, 43, 17, 0.5), inset 0px 1px 0px rgba(255, 195, 158, 0.5);
              }
              &1 {
                background: linear-gradient(137.26deg, #7EA2FF 24.01%, #B871FF 74.71%);
                box-shadow: 0px 0px 8px rgba(34, 11, 151, 0.2), inset 0px -1px 0px rgba(56, 17, 166, 0.5), inset 0px 1px 0px rgba(234, 218, 255, 0.5);
              }
              &2 {
                background: linear-gradient(180deg, #67D4F4 0%, #188FF2 75.52%);
                box-shadow: 0px 0px 8px rgba(24, 143, 242, 0.2), inset 0px -1px 0px #0873CC, inset 0px 1px 0px rgba(230, 255, 250, 0.5);
              }
            }
            &.assistance{
              background: linear-gradient(180deg, #C964F3 4.69%, #9700D9 44.27%, #7004A3 83.33%);
              box-shadow: 0px 0px 8px rgba(151, 0, 217, 0.3), inset 0px -1px 0px #730AA2, inset 0px 1px 0px #CE78F3;
              &0 {
                background: linear-gradient(180deg, #C964F3 4.69%, #9700D9 44.27%, #7004A3 83.33%);
                box-shadow: 0px 0px 8px rgba(151, 0, 217, 0.3), inset 0px -1px 0px #730AA2, inset 0px 1px 0px #CE78F3;
              }
              &1 {
                background: linear-gradient(180deg, #FFBE1F 4.69%, #F1771E 83.33%);
                box-shadow: 0px 0px 8px #F2911F, inset 0px -1px 0px #F37908, inset 0px 1px 0px #FFD597;
              }
              &2 {
                background: linear-gradient(180deg, #47FDD5 0%, #0EC1F4 80.73%);
                box-shadow: 0px 0px 8px #94E7FF, inset 0px -1px 0px #028EB6, inset 0px 1px 0px #BBFFF0;
              }
              &3 {
                background: linear-gradient(180deg, #F99CFF 4.69%, #BD00FF 100%);
                box-shadow: 0px 0px 8px rgba(161, 20, 209, 0.2), inset 0px -1px 0px #8D0DB9, inset 0px 1px 0px rgba(255, 255, 255, 0.5);
              }
            }
            &.lightup{
              background: linear-gradient(180deg, #28D4FE 0%, #4870FF 75.52%);
              box-shadow:0px 0px 8px rgba(78, 173, 241, 0.5), inset 0px -1px 0px rgba(58, 154, 255, 0.7), inset 0px 1px 0px rgba(173, 237, 255, 0.5);
              &3 {
                background: linear-gradient(180deg, #FF8551 0%, #F5BD2B 0.01%, #ED6F27 100%);
                box-shadow: 0px 0px 8px rgba(226, 88, 52, 0.5), inset 0px -1px 0px #CB5614, inset 0px 1px 0px #FFDD8E;
              }
              &4 {
                background: linear-gradient(180deg, #77C586 0%, #A1D155 0.01%, #40AE55 75.52%);
                box-shadow: 0px 0px 8px rgba(32, 146, 54, 0.5), inset 0px -1px 0px #329B46, inset 0px 1px 0px #C7F18D;
              }
            }
            &.cultivate {
              background: linear-gradient(180deg, #F4B424 0%, #C8811E 75.52%);
              box-shadow: 0px 0px 8px rgba(149, 99, 32, 0.5), inset 0px -1px 0px #A5605C, inset 0px 1px 0px #F9D77D;
            }
            &.haggle{
              background: linear-gradient(320.66deg, #7002FD 25.69%, #C971FF 78.73%);
              box-shadow: 0px 0px 8px rgba(34, 11, 151, 0.2), inset 0px -1px 0px rgba(56, 17, 166, 0.5), inset 0px 1px 0px rgba(234, 218, 255, 0.5);
            }

            .typeName {
              // margin-top: 18px;
              // margin-left: 20px;
              width: 40px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background: rgba(255, 255, 255, 0.4);
              border-radius: 4px;
              font-weight: 600;
              font-size: 12px;
              margin-bottom:10px;
              
              &.lucky{color: #E94D26}
              &.coupon {color: #E15269}
              &.purchase{
                color: #E15269;
                &0 {
                  color: #E15269;
                }
                &1 {
                  color: #E990FF;
                }
                &2 {
                  color: #188FF2;
                }
              }
              &.assistance{
                color: #920BD2;
                &0 {
                  color: #920BD2;
                }
                &1 {
                  background: #F8E8B1;
                  color: #F68B1F;
                }
                &2 {
                  background: #C5FFF8;
                  box-shadow: 0px 0px 8px rgba(148, 231, 255, 0.3), inset 0px -1px 0px #028EB6, inset 0px 1px 0px #BBFFF0;
                  color: #06B9BF;
                }
                &3 {
                  color: #C20CFF;
                }
              }
              &.haggle{
                color: #7002FD;
              }
              &.lightup{
                color: #135DCB;
                &3 {
                  color: #E25834;
                }
                &4 {
                  color: #94D13B;
                }
              }
              &.cultivate {
                color: #C58034;
              }
            }

            .couponTitle {
              font-weight: 500;
              font-size: 18px;
              line-height: 24px;
              color: #FFFFFF;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .couponInfo {
              font-size: 12px;
              line-height: 16px;
              margin-top: 2px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              &.lucky{color: #F2D5AB}
              &.coupon{color: #FFE68E}
              &.purchase{
                color: #FFE68E;
                &0 {
                  color: #FFE68E;
                }
                &1 {
                  color: #FFEDAD;
                }
                &2 {
                  color: #B5FCFE;;
                }
              }
              &.assistance{
                color: #F1B4FB;
                &0 {
                  color: #F1B4FB;
                }
                &1 {
                  color: #F8E8B1;
                }
                &2 {
                  color: #006981;
                }
                &3 {
                  color: #FFFFFF;
                }
              }
              &.haggle{
                color: #FFEDAD;
              }
              &.lightup{
                color: #ADE3FE;
                &3 {
                  color: #FFFFFF;
                }
                &4 {
                  color: #FFFFFF;
                }
              }
              &.cultivate {
                color: rgba(255, 255, 255, 0.6);
              }
            }
          }

          .itemIntro {
            width: 96px;
            margin: 10px 0 10px -60px;
            border-radius:0 6px 6px 0;
            padding:5px 5px 5px 2px;
            &.lucky{
                background: #FFECD1;
                box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
            }
            &.coupon {
              background: #FFECD1;
              box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4)
            }
            &.purchase{
              background: #FFECD1;
              box-shadow:2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
              &0 {
                background: #FFECD1;
                box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
              }
              &1 {
                background: #F5F1FF;
                box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
              }
              &2 {
                background: #FFF7EC;
                box-shadow: 2px 0px 2px rgba(24, 143, 242, 0.3), inset 1px 0px 2px #177FCD;
              }
            }
            &.assistance{
              background: #FFF4E6;
              box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
              &0 {
                background: #FFF4E6;
                box-shadow: 2px 0px 2px rgba(92, 60, 30, 0.3), inset 1px 0px 2px rgba(99, 26, 10, 0.4);
              }
              &1 {
                background: #FDF4E7;
              }
              &2 {
                background: #FFFBF5;
                box-shadow: 2px 0px 2px rgba(106, 106, 106, 0.3), inset 1px 0px 2px #0CA3C5;
              }
              &3 {
                background: #FFFFFF;
                box-shadow: 2px 0px 2px rgba(176, 115, 223, 0.3), inset 1px 0px 2px #FCC6FF;
              }
            }
            &.haggle{
              background: #F5F1FF;
              box-shadow: 2px 0px 2px #E4D7FF, inset 1px 0px 2px #D6B7FF;        
            }
            &.lightup{
              background:#E8EDF0;
              box-shadow: 2px 0px 2px rgba(81, 118, 167, 0.5), inset 1px 0px 2px rgba(122, 161, 198, 0.5);
              &3 {
                background: #F5F5F5;
                box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.2), inset 1px 0px 2px rgba(226, 88, 52, 0.5);
              }
              &4 {
                background: #F5F5F5;
                box-shadow: 2px 0px 2px rgba(0, 0, 0, 0.2), inset 1px 0px 2px rgba(31, 139, 52, 0.5);
              }
            }
            &.cultivate {
              background: #F4F8E8;
              box-shadow: 2px 0px 2px rgba(81, 118, 167, 0.5), inset 1px 0px 2px rgba(122, 161, 198, 0.5);
            }
            .itemIntroBox{
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              // margin:
              width:100%;
              height:100%;
              border: 1px solid #F1CEB6;
              border-left:none;
              box-sizing: border-box;
              border-radius: 2px;
              &.purchase {
                &1 {
                  border: 1px solid #CFCEFF;
                }
                &2 {
                  border: 1px solid #A4C9DD;
                }
              }
              &.assistance {
                &1 {
                  border-color: #E9DCD2;
                }
                &2 {
                  border-color: #0EC1F4;
                }
                &3 {
                  border-color: #E660FA;
                }
              }
              &.haggle {
                border: 1px solid #CFCEFF;
              }
              &.lightup {
                &3 {
                  border-color: #CCD3D7;;
                }
                &4 {
                  border-color: #CCD3D7;;
                }
              }
              &.cultivate {
                border-color: #CCD3D7;
              }
            }

            .discount, .reduce {
              font-size: 14px;
              
              &.lucky{color: #E94D26}
              &.coupon {
                color: #E15269;
              }
              &.purchase{
                color: #E15269;
                &0 {
                  color: #E15269;
                }
                &1 {
                  color: #E990FF;
                }
                &2 {
                  color: #188FF2;
                }
              }
              &.assistance{
                color: #723DB6;
                &0 {
                  color: #723DB6;
                }
                &1 {
                  color: #F68B1F;
                }
                &2 {
                  color: #06B9BF;
                }
                &3 {
                  color: #E049FF;
                }
              }
              &.haggle{
                color: #7002FD;
              }
              &.lightup{
                color: #135DCB;
                &3 {
                  color: #E25834
                }
                &4 {
                  color: #94D13B;
                }
              }
              &.cultivate {
                color: #C58034;
              }

              span {
                font-family: DIN Alternate;
                font-style: normal;
                font-weight: bold;
                font-size: 32px;
              }
            }

            .receive {
              width: 80px;
              height: 24px;
              margin-top: 5px;
              border-radius: 12px;
              font-weight: 500;
              font-size: 12px;
              line-height: 24px;
              color: #FFFFFF;
              text-align: center;
              &.lucky{background: #EE7E31}
              &.coupon {
                background: #E15269;
              }
              &.purchase{
                background: #E15269;
                &0 {
                  background: #E15269;
                }
                &1 {
                  background: #E990FF;
                }
                &2 {
                  background: #188FF2;
                }
              }
              &.assistance{
                background: #723DB6;
                &0 {
                  background: #723DB6;
                }
                &1 {
                  background: #F68B1F;
                }
                &2 {
                  background: #06B9BF;
                }
                &3 {
                  background: #E049FF;
                }
              }
              &.haggle{
                background: #7002FD;
              }
              &.lightup{
                background: #135DCB;
                &3 {
                  background: #E25834;
                }
                &4 {
                  background: #94D13B;
                }
              }
              &.cultivate {
                background: #C58034;
              }
            }
          }
        }
      }
    }
  }
}
</style>
